import React from "react";
import PropTypes from "prop-types";

import elementsMap from "./elementsMap";

// eslint-disable-next-line react/prop-types
const ContentElements = ({ element = {}, analytics }) => {
  const Element = elementsMap[element.type];

  if (typeof Element === "undefined") {
    return null;
  }

  return <Element data={element} analytics={analytics} />;
};

export default ContentElements;

ContentElements.propTypes = {
  element: PropTypes.object,
};
